var allDisputes = {
    backToActivity: 'Back to Activity',
    caseId: 'Your Case ID #',
    inquiries: "If you recently opened a dispute and it's not appearing, please allow up to 3 business days for the dispute to display online. For inquiries about any other disputes or the resolution of your dispute, please contact us via <0>Online Chat.</0>",
    manageDisputes: 'Manage Disputes',
    noDisputes: 'You have no billing disputes within the past 6 months.',
    noDisputesParagraph1: 'Recently opened disputes should appear within 3 business days —',
    noDisputesParagraph2: 'Please use our Online Chat. Please refresh the page or try again later.',
    disputeError: "We're having trouble retrieving your information",
    pleaseTryAgain: 'Please try again later or reach out to us via <0>Online Chat.</0>',
    ifYouHaveDocs: 'If you have documentation to support your dispute, please see how to share with us via our <0>Online Chat.</0> Be sure to include any additional details you feel would help resolve your dispute.'
};
export default allDisputes;
//# sourceMappingURL=allDisputes.js.map